import { Box, Button, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import { SoftChip } from '../components/ui';
import { RT } from '../theme/retentionTheme';
import TrainerStatusInactive from '../../crd/myworkspace/NewAdmissionRegister/TrainerMapping/TrainerStatusInactive';

// The admission register's tutor status change (Active / Temporary Inactive / Inactive), inside the retention Tutor
// mapping stage. Same rows (GET admission-register/get-trainer-mapping-data/:courseEnrollmentId) and the same dialog and
// API (PUT admission-register/change-trainer-status/:subjectEnrollmentId) as the admission register's Tutor Mapping page.

export const TUTOR_STATUS = {
  1: { label: 'Active', color: RT.success, icon: 'solar:check-circle-bold' },
  2: { label: 'Temporary Inactive', color: RT.warning, icon: 'solar:pause-circle-bold' },
  0: { label: 'Inactive', color: RT.error, icon: 'solar:close-circle-bold' },
};

const order = (s) => ({ 1: 0, 2: 1, 0: 2 }[Number(s)] ?? 3); // active first, then temporary inactive, then inactive

export default function TutorStatusList({ rows, dispatchParams, onChanged }) {
  if (!rows.length) return null;
  const sorted = [...rows].sort((a, b) => order(a.mapping_status) - order(b.mapping_status) || b.trainer_assignment_id - a.trainer_assignment_id);
  return (
    <Box sx={{ mt: 1.5, pt: 1.5, borderTop: `1px dashed ${RT.line}` }}>
      <Typography variant="caption" sx={{ color: RT.muted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4 }}>
        Tutor status
      </Typography>
      <Stack gap={0.75} sx={{ mt: 0.75 }}>
        {sorted.map((row) => {
          const st = TUTOR_STATUS[Number(row.mapping_status)] || TUTOR_STATUS[0];
          return (
            <Stack key={row.trainer_assignment_id} direction="row" alignItems="center" gap={1} flexWrap="wrap">
              <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 160 }}>
                {row.full_name || 'Tutor'}
              </Typography>
              <SoftChip label={st.label} icon={st.icon} color={st.color} />
              {row.session_duration ? (
                <Typography variant="caption" sx={{ color: RT.muted }}>
                  {row.session_duration} min
                </Typography>
              ) : null}
              <Box sx={{ ml: 'auto' }}>
                <TrainerStatusInactive
                  activeType={Number(row.mapping_status)}
                  row={row}
                  dispatchParams={dispatchParams}
                  crm={false}
                  onChanged={onChanged}
                  renderTrigger={(open) => (
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<Icon icon="solar:refresh-square-bold" width={16} />}
                      onClick={open}
                    >
                      Change status
                    </Button>
                  )}
                />
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
}
